"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sec2deg = exports.normalizeAngle = exports.time2deg = exports.deg2time = exports.angle2deg = exports.decimal2degreeMinutesSeconds = exports.decimal2degreeMinutes = exports.deg2angle = exports.rad2deg = exports.deg2rad = void 0;
var math_1 = require("./math");
function deg2rad(degrees) {
    return degrees * (Math.PI / 180);
}
exports.deg2rad = deg2rad;
function rad2deg(radians) {
    return radians * (180 / Math.PI);
}
exports.rad2deg = rad2deg;
function deg2angle(deg, short) {
    if (short === void 0) { short = false; }
    return decimal2degreeMinutesSeconds(deg, short);
}
exports.deg2angle = deg2angle;
function decimal2degreeMinutes(decimal, short, prefixes) {
    if (short === void 0) { short = false; }
    var sign = getSignPrefix(decimal, prefixes);
    decimal = Math.abs(decimal);
    var degPart = Math.floor(decimal);
    var min = (0, math_1.round)((decimal - degPart) * 60, 5);
    var degString = degPart + '° ';
    var minString = (0, math_1.pad)(min, 2) + '\'';
    if (short && degPart === 0.0) {
        return sign + minString;
    }
    return sign + degString + minString;
}
exports.decimal2degreeMinutes = decimal2degreeMinutes;
function decimal2degreeMinutesSeconds(decimal, short, prefixes) {
    if (short === void 0) { short = false; }
    var sign = getSignPrefix(decimal, prefixes);
    decimal = Math.abs(decimal);
    var degPart = Math.floor(decimal);
    var min = Math.floor((decimal - degPart) * 60);
    var sec = (0, math_1.round)((decimal - degPart - min / 60) * 3600, 3);
    var secParts = sec.toString().split('.');
    var degString = degPart + '° ';
    var minString = (0, math_1.pad)(min, 2) + '\' ';
    var secString = (secParts.length === 1 ? (0, math_1.pad)(sec, 2) : (0, math_1.pad)(secParts[0], 2) + '.' + secParts[1]) + '"';
    if (short && degPart === 0.0 && min === 0.0) {
        return sign + secString;
    }
    if (short && degPart === 0.0) {
        return sign + minString + secString;
    }
    return sign + degString + minString + secString;
}
exports.decimal2degreeMinutesSeconds = decimal2degreeMinutesSeconds;
function angle2deg(angle) {
    var matches = angle.match(/(-?)([0-9]+)°.*?([0-9]+)'.*?([0-9.]+)"/);
    if (!matches) {
        throw new Error('false angle format');
    }
    var sign = matches[1].trim() === '-' ? -1 : 1;
    var deg = parseInt(matches[2]);
    var min = parseInt(matches[3]);
    var sec = parseFloat(matches[4]);
    return sign * (deg + min / 60 + sec / 3600);
}
exports.angle2deg = angle2deg;
function deg2time(angle) {
    var sign = angle < 0 ? '-' : '';
    var time = Math.abs(angle / 15);
    var hour = Math.floor(time);
    var min = Math.floor((time - hour) * 60);
    var sec = (0, math_1.round)((time - hour - min / 60) * 3600, 3);
    var secParts = sec.toString().split('.');
    var hourString = sign + hour;
    var minString = (0, math_1.pad)(min, 2);
    var secString = secParts.length === 1 ? (0, math_1.pad)(sec, 2) : (0, math_1.pad)(secParts[0], 2) + '.' + secParts[1];
    return "".concat(hourString, "h ").concat(minString, "m ").concat(secString, "s");
}
exports.deg2time = deg2time;
function time2deg(timeAngle) {
    var matches = timeAngle.match(/(-?)([0-9]+)h.*?([0-9]+)m.*?([0-9.]+)s/);
    if (!matches) {
        throw new Error('false time angle format');
    }
    var sign = matches[1].trim() === '-' ? -1 : 1;
    var deg = parseInt(matches[2]);
    var min = parseInt(matches[3]);
    var sec = parseFloat(matches[4]);
    var angleDeg = sign * (deg + min / 60 + sec / 3600);
    return angleDeg * 15;
}
exports.time2deg = time2deg;
function normalizeAngle(degrees, baseAngle) {
    if (baseAngle === void 0) { baseAngle = 360.0; }
    var angle = degrees % baseAngle;
    if (angle < 0) {
        angle = angle + baseAngle;
    }
    return angle;
}
exports.normalizeAngle = normalizeAngle;
function sec2deg(seconds) {
    return seconds / 3600;
}
exports.sec2deg = sec2deg;
function getSignPrefix(decimal, prefixes) {
    if (prefixes) {
        return decimal < 0 ? prefixes.negativePrefix : prefixes.positivePrefix;
    }
    return decimal < 0 ? '-' : '';
}
